import GraphData from "../../interfaces/Graphs/GraphData";
import GraphComponent from "./Graph";
import { useTranslation } from 'react-i18next';

interface GraphContentProps {
    endpoint: string,
    name: string,
    graphData: GraphData[],
    isAnimals?: boolean,
    minYear?: number
}
export default function TGraphContent(props: GraphContentProps) {
    const { t } = useTranslation("traffic");

    // Adjust endpoint 
    let adjustedEndpoint = props.endpoint;
    if (props.isAnimals && props.endpoint.endsWith('/animals')) {
        adjustedEndpoint = props.endpoint.slice(0, -8); // Remove '/animals'
    }

    return (
        <div>
            {!props.isAnimals && (
                <h2 style={{textAlign: "center"}}>
                    {`${t("TGraphs.nadpis")} : ${props.name}`}
                </h2>
            )}
            <GraphComponent baseUrl_API={adjustedEndpoint} GraphData={props.graphData} GraphSeriesName={t("TGraphs.pocet")} isAnimals={props.isAnimals} minYear={props.minYear} title={props.isAnimals ? `${t("TGraphs.nadpisSoZverouShort")}: ${props.name}` : undefined} graphName={props.isAnimals ? props.name : undefined}/>
        </div>
    );
}